import { AntDesign } from "@expo/vector-icons";
import React from "react";
import {
  DragDropActionTypes,
  useDragDropContext,
} from "../../../../../../utilities/drag-drop";
import {
  PageItemType,
  useCreateTile,
} from "../../../../../../utilities/layout";
import { useLayoutProvider } from "../../../../utils/layout";
import { InteractivityWrapper } from "../../../InteractiveQuickKey/components";
import { QuickKey } from "../../../QuickKey";
import { CommonQuickKeyProps } from "../../types";
import { useThemeProvider } from "@towersystems/roam-common-native";

export const PlaceholderQuickKey = React.forwardRef<any, CommonQuickKeyProps>(
  ({ droppable = true, ...props }, ref) => {
    const { layout } = useLayoutProvider();
    const { performLayoutAction } = useDragDropContext();
    const { openCreateTile } = useCreateTile();
    const { colors } = useThemeProvider();
    const { item } = props;

    function handleDrop(droppedItem: PageItemType) {
      if (!droppedItem.config) return;

      const input = droppedItem.config;

      performLayoutAction({
        type: DragDropActionTypes.UPDATE_POS_LAYOUT_KEY,
        payload: {
          id: droppedItem.id,
          ...input,
          position: item.position,
        },
      });
    }

    function handleEnter() {
      // TODO: add animation
    }

    function handlePress() {
      // open modal to add node
      if (!layout) return;

      const config = {
        layoutId: layout.id,
        position: item.position,
      };

      openCreateTile(config);
    }

    return (
      <InteractivityWrapper
        {...props}
        draggable={false}
        droppable={droppable}
        onPress={handlePress}
        onDrop={handleDrop}
        onEnter={handleEnter}
      >
        <QuickKey
          ref={ref}
          onPress={handlePress}
          style={{
            borderWidth: 2,
            borderStyle: "dashed",
            borderColor: "rgba(0,0,0,0.1)",
          }}
          backgroundColor="rgba(0,0,0,0.05)"
          iconPrimary={
            <AntDesign name="pluscircleo" size={24} color="rgba(0,0,0,0.1)" />
          }
        />
      </InteractivityWrapper>
    );
  }
);
